import type { PublicOwnerBranding } from '@pay/shared';
import { formatOrgnr, oneLineAddress } from '../lib/format';

interface CustomerFooterProps {
  /** Mangler når siden ikke vet hvem som eier lenken (ugyldig/utløpt): da vises de generelle vilkårene. */
  owner?: PublicOwnerBranding | null;
  /** På selve vilkårssiden. */
  hideTermsLink?: boolean;
}

// Bunntekst på alle sider sluttkunden ser: hvem som selger (navn, org.nr., adresse, e-post) og lenke
// til salgsvilkårene. Vilkårene åpnes i ny fane så kunden ikke mister betalingssiden.
export function CustomerFooter({ owner, hideTermsLink }: CustomerFooterProps) {
  return (
    <footer className="text-center text-xs text-slate-500 space-y-1 py-4">
      {owner && (
        <div>
          {owner.name} · Org.nr. {formatOrgnr(owner.orgnr)}
          {owner.address ? ` · ${oneLineAddress(owner.address)}` : ''}
          {owner.support_email && (
            <>
              {' · '}
              <a href={`mailto:${owner.support_email}`} className="hover:underline">
                {owner.support_email}
              </a>
            </>
          )}
        </div>
      )}
      <div>
        {!hideTermsLink && (
          <>
            <a
              href={owner ? `/vilkar/${owner.id}` : '/vilkar'}
              target="_blank"
              rel="noopener"
              className="underline hover:text-slate-700"
            >
              Salgsvilkår
            </a>
            {' · '}
          </>
        )}
        Betalingen håndteres trygt av Pay
      </div>
    </footer>
  );
}
